import { useEffect, useRef, useCallback } from "react";
import {
  Modal1Wrapper,
  Modal1Content,
  Modal1HeaderWrapper,
  Modal1BodyWrapper,
} from "./modalElements";

export const Modal1 = ({ children, isOpen, toggle }) => {
  const modalRef = useRef(null);

  const clickListener = useCallback(
    (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) toggle();
    },
    [toggle]
  );
  const escapeListener = useCallback(
    (e) => {
      if (e.keyCode === 27) toggle();
    },

    [toggle] // seslint-disable-line react-hooks/exhaustive-deps
  );

  useEffect(() => {
    if (isOpen) {
      document.body.addEventListener("click", clickListener);
      document.addEventListener("keydown", escapeListener, false);
    } else {
      document.body.removeEventListener("click", clickListener);
      document.removeEventListener("keydown", escapeListener, false);
    }
  }, [isOpen, clickListener, escapeListener]);

  return (
    <Modal1Wrapper visible={isOpen}>
      <Modal1Content ref={modalRef}>{children}</Modal1Content>
    </Modal1Wrapper>
  );
};

export const Modal1Header = ({ children, toggle, success }) => {
  return (
    <Modal1HeaderWrapper success={success}>
      {children}
      <i className="fas fa-times" onClick={toggle} />
    </Modal1HeaderWrapper>
  );
};
export const Modal1Body = ({ children }) => {
  return <Modal1BodyWrapper>{children}</Modal1BodyWrapper>;
};
